import { required } from 'vuelidate/lib/validators';
import creditCardPreCalculationApi from '../../../api/creditcard-precalculation-api';
import VueFocus from 'vue-focus';
import VueFormNotification from '@ui-common/vue-form-notification';
import VueTab from '@ui-common/vue-tab';
import { APPLICATION_TYPE } from '../creditcard-precalculation';
const VHK_TA_SUCCESS = 'HK_ELOKALKULACIO_SIKERES_VHK-T-KER';
const VHK_TA_DOWNGRADE = 'HK_ELOKALKULACIO_DOWNGRADE_VHK-T_KER';
const ALL_CARD_TA = 'HK_ELOKALKULACIO_DOWNGRADE_MEGNEZEM_AZ_OSSZES_HITELKARTYAT';
const HITELKARTYA_TIPUSA = 'HITELKARTYA_TIPUSA';
const FOLYOSZAMLA_RESZLETEK = 'HK_ELOKALKULACIO_MEGNEZEM_A_FOLYOSZLAHITEL_RESZLETEIT';

export default {
	mixins: [VueFocus.mixin],
	data() {
		return {
			activeTab: 'tab0',
			focusedTab: 0,
			needFocusLoose: null
		};
	},
	props: {
		calculationResult: {
			required
		},
		requestedCard: {
			required
		},
		swImgPath: {
			required
		},
		folyoszamlaHitelLink: {
			required
		},
		hitelkartyaIgenylesLink: {
			required
		},
		hitelkartyakLink: {
			required
		},
		vhkProductId: {
			required
		},
		vhkQuestionId: {
			required
		},
		preCalculated: {
			required
		},
		type: {
			required: false
		}
	},
	computed: {
		filteredRecommendedCards() {
			return this.calculationResult.availableCards.filter((card) => {
				return card.cardId != this.requestedCard;
			});
		},
		isMobile() {
			return this.$resize && this.$mq.below(767);
		},
		isLanding() {
			return this.type == APPLICATION_TYPE.LANDING;
		}
	},
	components: {
		VueFormNotification,
		VueTab
	},
	watch: {
		calculationResult() {
			this.$scrollTo(this.$refs['precalculation-container'], { duration: 500 });
		}
	},
	methods: {
		changeTab(tabId, looseFocus) {
			this.activeTab = 'tab' + tabId;
			this.focusedTab = tabId;
			this.needFocusLoose = looseFocus;
		},
		startCalculation(cardId) {
			let eligible = this.calculationResult.eligibleForSelectedCard;
			this.$emit('start-calculation', { cardId, eligible });
		},
		onBlurFunction() {
			if (this.needFocusLoose) {
				this.focusedTab = null;
			}
			this.needFocusLoose = true;
		},
		scrollToCallRequest() {
			document.getElementById('call-request').scrollIntoView();
		},
		openVhkTa(cardId) {
			let eventType = '';
			if (this.calculationResult.eligibleForSelectedCard) {
				// ha jogosult az eredetileg ig�nyelt k�rty�ra (sikeres)
				eventType = VHK_TA_SUCCESS;
			} else if (this.filteredRecommendedCards.length) {
				// sikeretelen, de van downsell aj�nlat
				eventType = VHK_TA_DOWNGRADE;
			}
			let taData = { eventType, dataElements: [{ name: HITELKARTYA_TIPUSA, value: cardId }] };
			this.$emit('send-ta', taData);
		},
		showAllCard(cardId) {
			return () => {
				return this.allCreditCardLinkTa(cardId);
			};
		},
		allCreditCardLinkTa(cardId) {
			let taData = { eventType: ALL_CARD_TA, dataElements: [{ name: HITELKARTYA_TIPUSA, value: cardId }] };
			return creditCardPreCalculationApi.sendTa(taData);
		},
		goToAccountLinkTa() {
			let taData = { eventType: FOLYOSZAMLA_RESZLETEK, dataElements: [] };
			return creditCardPreCalculationApi.sendTa(taData);
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.$scrollTo(this.$refs['precalculation-container'], { duration: 500 });
		});
	}
};
